import { render, staticRenderFns } from "./CompositionApiComputedRef.vue?vue&type=template&id=43426ca2&"
import script from "./CompositionApiComputedRef.vue?vue&type=script&lang=js&"
export * from "./CompositionApiComputedRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports